import React, { FunctionComponent } from 'react';
import { Record } from 'immutable';
import { DictionaryTag } from 'app/constants/schemas';
import { DICTIONARY_TAGS } from 'app/constants/enums/DictionaryTag';
import BooleanOptionMultiSelect, { makeBooleanValues } from 'app/components/editor/BooleanOptionMultiSelect';
import { useI18n } from 'app/components/localization';
import { useDispatch } from 'react-redux';
import { addDictionaryTag, removeDictionaryTag } from 'app/models/route/actions';
import { useHistory } from 'app/components/router/History';
import { getDictionaryTagOptions } from 'app/models/route/selectors';
import { DictionaryTagId } from 'app/constants/enums/DictionaryTag/data';

type DictionaryTagFilterMap = {
  [K in DictionaryTagId ]: boolean | undefined;
};

const DICTIONARY_TAGS_NAMES: { [K in DictionaryTagId]: DictionaryTag } = Object.fromEntries(
  DICTIONARY_TAGS.map(tag => [tag.id, tag]),
);

export class DictionaryTagOptions extends Record<DictionaryTagFilterMap>(
  Object.fromEntries(DICTIONARY_TAGS.map(tag => [tag.id, undefined])),
) {}

const DictionaryTagSelector: FunctionComponent = () => {
  const { t } = useI18n();
  const dispatch = useDispatch();
  const history = useHistory();
  const values = getDictionaryTagOptions(history);
  return (
    <BooleanOptionMultiSelect
      values={makeBooleanValues(values)}
      filters={DICTIONARY_TAGS}
      names={DICTIONARY_TAGS_NAMES}
      noResults={t('admin.editor.dictionary-tag-filter.no-results')}
      placeholder={t('admin.editor.dictionary-tag-filter.placeholder')}
      onSelect={(id, value) => dispatch(addDictionaryTag(history, id, value))}
      onRemove={id => dispatch(removeDictionaryTag(history, id))}
      closeOnAdd
    />
  );
};

export default DictionaryTagSelector;
